// Existing productionNoticeHTML() reads this copy on EVERY product/Studio/cart
// render, including late async data. LOCAL candidate; no new observer or API.
(function(){'use strict';
 const text='Production: 2–5 business days. Shipping time is additional and depends on the shipping method and destination selected at checkout. Estimated delivery is shown when available at checkout.';
 // Load after the existing PS_MOBILE_COPY definition. The established render
 // hook owns note creation, locations, visibility and design-approval copy.
 window.PS_MOBILE_COPY||={};window.PS_MOBILE_COPY.production_notice=text;
 for(const p of document.querySelectorAll('.ps-production-note > p:first-child'))p.textContent=text;
})();
